import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
import Navbar from "./Components/Navbar.jsx";

import Switch from "./Components/Switch";
import Home from "./Components/Home";
import About from "./Components/About";
import Projects from "./Components/Projects";
import Achievements from "./Components/Achievements";
import AnimatedCursor from "./Components/animatedCursor";
import Profiles from "./Components/Profiles";

function App() {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [toggle, setToggle] = useState(true);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", checkMobileView);
    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  return (
    <Router>
      <div
        className="main"
        style={{
          backgroundColor: toggle === true ? "white" : "black",
          color: toggle === true ? "gray" : "#6060ff",
        }}
      >
        {isMobileView ? <></> : <AnimatedCursor />}

        <div onClick={() => setToggle(!toggle)} className="dark">
          <svg
            fill="none"
            stroke="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="switch-icons logo"
          >
            <path
              d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8V16Z"
              fill="currentColor"
            ></path>
            <path
              d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4V8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16V20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
              fill="currentColor"
              clipRule="evenodd"
              fillRule="evenodd"
            ></path>
          </svg>
        </div>
        <Switch isMobileView={isMobileView} />
        <Navbar theme={toggle ? "white" : "dark"} />
        <Routes>
          <Route
            exact
            path="/"
            element={<Home theme={toggle ? "white" : "dark"} />}
          />
          <Route
            exact
            path="/about"
            element={<About theme={toggle ? "white" : "dark"} />}
          />
          <Route
            exact
            path="/achievements"
            element={<Achievements theme={toggle ? "white" : "dark"} />}
          />
          <Route
            exact
            path="/projects"
            element={<Projects theme={toggle ? "white" : "dark"} />}
          />
          <Route
            exact
            path="/profiles"
            element={<Profiles theme={toggle ? "white" : "dark"} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
